import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';

import {
  AllocatedMenuListResponse,
  MenuManagementAllocatedMenuListParams,
  MenuManagementAllocatedMenuUpdateParams,
} from './hooks';
import { MenuManagementAllocatedMenuBulkCreateParams } from './hooks/bulkCreate/useMenuManagementBulkCreateAllocatedMenu';

interface Interface {
  list: (
    params: MenuManagementAllocatedMenuListParams
  ) => Promise<AllocatedMenuListResponse>;
  put: (params: MenuManagementAllocatedMenuUpdateParams) => Promise<void>;
  bulkCreate: (
    params: MenuManagementAllocatedMenuBulkCreateParams
  ) => Promise<void>;
}
export class MenuManagementAllocatedMenuService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(
    params: MenuManagementAllocatedMenuListParams
  ): Promise<AllocatedMenuListResponse> {
    const { associateBrandId, currentPage, limit, title } = params;
    const query =
      `?associate_brand_id=${associateBrandId}&current_page=${currentPage.toString()}&limit=${limit.toString()}&title=${title}` as const;
    return await this.restClient.get<AllocatedMenuListResponse>(
      `${TABLET_API_ORIGIN}/dashboard-api/allocated-menus${query}` as const
    );
  }

  public async put(
    params: MenuManagementAllocatedMenuUpdateParams
  ): Promise<void> {
    await this.restClient.put<MenuManagementAllocatedMenuUpdateParams, void>(
      `${TABLET_API_ORIGIN}/dashboard-api/allocated-menus` as const,
      params
    );
  }

  public async bulkCreate(
    params: MenuManagementAllocatedMenuBulkCreateParams
  ): Promise<void> {
    await this.restClient.post<
      MenuManagementAllocatedMenuBulkCreateParams,
      void
    >(`${TABLET_API_ORIGIN}/dashboard-api/allocated-menus` as const, params);
  }
}
